(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1539],{

/***/ 48146:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[chain]/collection-rankings",
      function () {
        return __webpack_require__(61780);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 61780:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _reservoir0x_reservoir_kit_ui__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(61897);
/* harmony import */ var components_Head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4049);
/* harmony import */ var components_Layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51943);
/* harmony import */ var components_common_ChainToggle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61955);
/* harmony import */ var components_common_CollectionsTimeDropdown__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39968);
/* harmony import */ var components_common_LoadingSpinner__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74431);
/* harmony import */ var components_primitives__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92902);
/* harmony import */ var components_rankings_CollectionRankingsTable__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71567);
/* harmony import */ var context_ChainContextProvider__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(43810);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(35430);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(67294);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(1852);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(react_responsive__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var usehooks_ts__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(5678);
/* harmony import */ var utils_chains__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(67418);
















const IndexPage = (param)=>{
    let { ssr  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_10__.useRouter)();
    const isSSR = "object" === "undefined";
    const isMounted = (0,hooks__WEBPACK_IMPORTED_MODULE_9__/* .useMounted */ .s4)();
    const compactToggleNames = (0,react_responsive__WEBPACK_IMPORTED_MODULE_14__.useMediaQuery)({
        query: "(max-width: 800px)"
    });
    const [sortByTime, setSortByTime] = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)("1DayVolume");
    const marketplaceChain = (0,hooks__WEBPACK_IMPORTED_MODULE_9__/* .useMarketplaceChain */ .gw)();
    let collectionQuery = {
        limit: 20,
        sortBy: sortByTime,
        includeTopBid: true
    };
    const { chain , switchCurrentChain  } = (0,react__WEBPACK_IMPORTED_MODULE_11__.useContext)(context_ChainContextProvider__WEBPACK_IMPORTED_MODULE_8__/* .ChainContext */ .p);
    (0,react__WEBPACK_IMPORTED_MODULE_11__.useEffect)(()=>{
        if (router.query.chain) {
            let chainIndex;
            for(let i = 0; i < utils_chains__WEBPACK_IMPORTED_MODULE_13__/* ["default"].length */ .ZP.length; i++){
                if (utils_chains__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP[i].routePrefix == router.query.chain) {
                    chainIndex = utils_chains__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP[i].id;
                }
            }
            if (chainIndex !== -1 && chainIndex) {
                switchCurrentChain(chainIndex);
            }
        }
    }, [
        router.query
    ]);
    if (chain.collectionSetId) {
        collectionQuery.collectionsSetId = chain.collectionSetId;
    } else if (chain.community) {
        collectionQuery.community = chain.community;
    }
    const { data , fetchNextPage , isFetchingPage , isValidating  } = (0,_reservoir0x_reservoir_kit_ui__WEBPACK_IMPORTED_MODULE_15__/* .useCollections */ .bX)(collectionQuery, {
        fallbackData: [
            ssr.collections[marketplaceChain.id]
        ]
    });
    let collections = data || [];
    const loadMoreRef = (0,react__WEBPACK_IMPORTED_MODULE_11__.useRef)(null);
    const loadMoreObserver = (0,usehooks_ts__WEBPACK_IMPORTED_MODULE_12__/* .useIntersectionObserver */ .S1)(loadMoreRef, {});
    (0,react__WEBPACK_IMPORTED_MODULE_11__.useEffect)(()=>{
        let isVisible = !!(loadMoreObserver === null || loadMoreObserver === void 0 ? void 0 : loadMoreObserver.isIntersecting);
        if (isVisible) {
            fetchNextPage();
        }
    }, [
        loadMoreObserver === null || loadMoreObserver === void 0 ? void 0 : loadMoreObserver.isIntersecting
    ]);
    let volumeKey = "allTime";
    switch(sortByTime){
        case "1DayVolume":
            volumeKey = "1day";
            break;
        case "7DayVolume":
            volumeKey = "7day";
            break;
        case "30DayVolume":
            volumeKey = "30day";
            break;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_Layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Head__WEBPACK_IMPORTED_MODULE_1__/* .Head */ .F, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xu, {
                css: {
                    p: 24,
                    height: "100%",
                    "@bp800": {
                        p: "$6"
                    }
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .kC, {
                        css: {
                            my: "$6",
                            gap: 65
                        },
                        direction: "column",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .kC, {
                                justify: "between",
                                align: "start",
                                css: {
                                    flexDirection: "column",
                                    gap: 24,
                                    "@bp800": {
                                        alignItems: "center",
                                        flexDirection: "row"
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .xv, {
                                        style: "h4",
                                        as: "h4",
                                        children: "Collection Rankings"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .kC, {
                                        align: "center",
                                        css: {
                                            gap: "$4"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_CollectionsTimeDropdown__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                compact: compactToggleNames && isMounted,
                                                option: sortByTime,
                                                onOptionSelected: (option)=>{
                                                    setSortByTime(option);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_ChainToggle__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
                                        ]
                                    })
                                ]
                            }),
                            isSSR || !isMounted ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_rankings_CollectionRankingsTable__WEBPACK_IMPORTED_MODULE_7__/* .CollectionRankingsTable */ .D, {
                                collections: collections,
                                volumeKey: volumeKey,
                                loading: isValidating
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xu, {
                                ref: loadMoreRef,
                                css: {
                                    display: isFetchingPage ? "none" : "block"
                                }
                            })
                        ]
                    }),
                    (isFetchingPage || isValidating) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .kC, {
                        align: "center",
                        justify: "center",
                        css: {
                            py: "$4"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_LoadingSpinner__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {})
                    })
                ]
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (IndexPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7948,4946,8957,1943,1236,9774,2888,179], function() { return __webpack_exec__(48146); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);